module.exports = __webpack_public_path__ + "img/news.f46a7fac.png";